import parseQueryString from './parseQueryString';

/**
 * Checks if viva_pnr query parameter is present in the current URL.
 * This is a pure utility function that can be used outside React components.
 *
 * @returns {boolean} True if viva_pnr is present in the URL, false otherwise
 */
const hasVivaPnr = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const queryParams = parseQueryString(window.location.search);
  return Boolean(queryParams.viva_pnr);
};

export default hasVivaPnr;
